import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {PersonLogin, RoleName} from './person/person-login';
import {PersonLoginService} from './services/person-login-service';

import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatIcon} from "@angular/material/icon";
import {MatButton} from "@angular/material/button";
import {BrandID} from './enums/brand-id';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, RouterLinkActive, RouterOutlet, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, MatButton]
})
export class AppComponent {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly router = inject(Router);


  // getHeaderLogoWhite(): string {
  //   let headerLogoWhite: string = "IEC Logo White.png";
  //   let brandIDs: BrandID[] = this.personLoginService.getBrandIDs();
  //
  //
  //   if (brandIDs && brandIDs.length > 0) {
  //     switch (brandIDs[0]) {
  //       case BrandID.IEC:
  //         headerLogoWhite = "IEC Logo White.png";
  //         break;
  //       case BrandID.CLM:
  //         headerLogoWhite = "ClimateMaster_Logo_White.png";
  //         break;
  //       case BrandID.CCG:
  //         break;
  //       case BrandID.CLC:
  //         break;
  //     }
  //   }
  //   return headerLogoWhite;
  // }

  // getHeaderClass(): string {
  //   let headerClass: string = 'header iecHeaderColor';
  //   let brandIDs: BrandID[] = this.personLoginService.getBrandIDs();
  //
  //   if (brandIDs && brandIDs.length > 0) {
  //     switch (brandIDs[0]) {
  //       case BrandID.IEC:
  //         headerClass = 'header iecHeaderColor';
  //         break;
  //       case BrandID.CLM:
  //         headerClass = 'header clmHeaderColor';
  //         break;
  //       case BrandID.CCG:
  //         break;
  //       case BrandID.CLC:
  //         break;
  //     }
  //   }
  //   return headerClass;
  // }

  // getCompanyWebsite(): string {
  //   let companyWebsite: string = 'https://www.iec-okc.com';
  //   let brandIDs: BrandID[] = this.personLoginService.getBrandIDs();
  //
  //   if (brandIDs && brandIDs.length > 0) {
  //     switch (brandIDs[0]) {
  //       case BrandID.IEC:
  //         companyWebsite = 'https://www.iec-okc.com';
  //         break;
  //       case BrandID.CLM:
  //         companyWebsite = 'https://www.climatemaster.com';
  //         break;
  //       case BrandID.CCG:
  //         break;
  //       case BrandID.CLC:
  //         break;
  //     }
  //
  //     return companyWebsite;
  //   }
  // }


  public hasRole(roleName: string): boolean {
    return this.personLoginService.hasRole(RoleName[roleName as keyof typeof RoleName]);
  }

  public isInternalOrRsm(): boolean {
    return this.personLoginService.isInternalOrRsm();
  }

  isBetaTesterOrAdmin(): boolean {
    return this.personLoginService.isBetaTester() || this.personLoginService.isAdmin();
  }

  isOutsideEngineer(): boolean {
    return this.personLoginService.isOutsideEngineer();
  }

  public getCurrentYear(): number {
    return new Date().getFullYear();
  }

  delegateTasks(): void {
    this.router.navigate(['userDelegation']);
  }

  isLoggedIn(): boolean {
    const personLogin = this.getCachedLogin();
    return !!(personLogin && personLogin.person.active);
  }

  private getCachedLogin(): PersonLogin | undefined {
    return this.personLoginService.getCachedLoginWithoutRedirect();
  }

  getUsername(): string {
    const personLogin = this.getCachedLogin();
    if (personLogin && personLogin.person) {
      return personLogin.person.description;
    }
    return '';
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['/']);
  }

}
